var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _g2, _path12, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewAutoFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 201,
    viewBox: "0 0 202 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2924 200.554C148.118 200.554 188.51 160.162 188.51 110.337C188.51 60.5112 148.118 20.1196 98.2924 20.1196C48.4668 20.1196 8.0752 60.5112 8.0752 110.337C8.0752 160.162 48.4668 200.554 98.2924 200.554Z",
    fill: "url(#paint0_linear_2112_10424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.963 35.8549H47.0217C40.7922 35.8549 35.7422 40.9049 35.7422 47.1344H158.243C158.243 40.9049 153.193 35.8549 146.963 35.8549Z",
    fill: "url(#paint1_linear_2112_10424)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7422 46.8202H158.243V140.119C158.243 144.267 156.595 148.245 153.662 151.178C150.729 154.111 146.75 155.759 142.602 155.759H51.3827C47.2345 155.759 43.2563 154.111 40.3232 151.178C37.39 148.245 35.7422 144.267 35.7422 140.119V46.8202Z",
    fill: "url(#paint2_linear_2112_10424)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.185 58.6053H56.8383C55.1651 58.6053 53.8086 59.9603 53.8086 61.6318C53.8086 63.3033 55.1651 64.6582 56.8383 64.6582H137.185C138.858 64.6582 140.215 63.3033 140.215 61.6318C140.215 59.9603 138.858 58.6053 137.185 58.6053Z",
    fill: "url(#paint3_linear_2112_10424)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.185 84.329H56.8383C55.1651 84.329 53.8086 85.684 53.8086 87.3554C53.8086 89.0269 55.1651 90.3819 56.8383 90.3819H137.185C138.858 90.3819 140.215 89.0269 140.215 87.3554C140.215 85.684 138.858 84.329 137.185 84.329Z",
    fill: "url(#paint4_linear_2112_10424)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.185 110.042H56.8383C55.1651 110.042 53.8086 111.397 53.8086 113.068C53.8086 114.74 55.1651 116.095 56.8383 116.095H137.185C138.858 116.095 140.215 114.74 140.215 113.068C140.215 111.397 138.858 110.042 137.185 110.042Z",
    fill: "url(#paint5_linear_2112_10424)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.185 135.756H56.8383C55.1651 135.756 53.8086 137.111 53.8086 138.782C53.8086 140.454 55.1651 141.809 56.8383 141.809H137.185C138.858 141.809 140.215 140.454 140.215 138.782C140.215 137.111 138.858 135.756 137.185 135.756Z",
    fill: "url(#paint6_linear_2112_10424)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2112_10424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2929 104.528H13.5095C10.0724 104.528 7.28613 107.314 7.28613 110.751V171.903C7.28613 175.34 10.0724 178.126 13.5095 178.126H56.2929C59.73 178.126 62.5163 175.34 62.5163 171.903V110.751C62.5163 107.314 59.73 104.528 56.2929 104.528Z",
    fill: "url(#paint7_linear_2112_10424)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5203 135.108H18.2852C17.166 135.108 16.2588 136.015 16.2588 137.134V137.141C16.2588 138.26 17.166 139.167 18.2852 139.167H51.5203C52.6395 139.167 53.5467 138.26 53.5467 137.141V137.134C53.5467 136.015 52.6395 135.108 51.5203 135.108Z",
    fill: "url(#paint8_linear_2112_10424)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5386 163.674H18.589C17.4795 163.674 16.5801 164.553 16.5801 165.637V165.643C16.5801 166.728 17.4795 167.607 18.589 167.607H51.5386C52.6481 167.607 53.5476 166.728 53.5476 165.643V165.637C53.5476 164.553 52.6481 163.674 51.5386 163.674Z",
    fill: "url(#paint9_linear_2112_10424)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5386 148.734H18.589C17.4795 148.734 16.5801 149.613 16.5801 150.697V150.704C16.5801 151.788 17.4795 152.667 18.589 152.667H51.5386C52.6481 152.667 53.5476 151.788 53.5476 150.704V150.697C53.5476 149.613 52.6481 148.734 51.5386 148.734Z",
    fill: "url(#paint10_linear_2112_10424)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4366 113.963H20.7245C18.5731 113.963 16.8291 115.707 16.8291 117.858V120.554C16.8291 122.705 18.5731 124.449 20.7245 124.449H30.4366C32.588 124.449 34.332 122.705 34.332 120.554V117.858C34.332 115.707 32.588 113.963 30.4366 113.963Z",
    fill: "url(#paint11_linear_2112_10424)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2112_10424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.085 9H130.829C128.627 9 126.842 10.7851 126.842 12.9872V35.1986C126.842 37.4007 128.627 39.1858 130.829 39.1858H178.085C180.287 39.1858 182.072 37.4007 182.072 35.1986V12.9872C182.072 10.7851 180.287 9 178.085 9Z",
    fill: "url(#paint12_linear_2112_10424)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.449 153.817L157.037 141.058L189.7 170.647L189.698 170.649L191.442 172.229C193.136 173.763 194.15 175.906 194.261 178.187C194.372 180.468 193.572 182.699 192.036 184.39C190.5 186.082 188.354 187.094 186.07 187.205C183.787 187.317 181.552 186.517 179.859 184.983L178.115 183.403L178.112 183.406L145.449 153.817Z",
    fill: "url(#paint13_linear_2112_10424)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2112_10424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.283 119.546C169.283 146.239 147.617 167.877 120.892 167.877C94.1656 167.877 72.5 146.239 72.5 119.546C72.5 92.8542 94.1656 71.2158 120.892 71.2158C147.617 71.2158 169.283 92.8542 169.283 119.546ZM161.86 119.546C161.86 142.144 143.518 160.463 120.891 160.463C98.2648 160.463 79.9224 142.144 79.9224 119.546C79.9224 96.948 98.2648 78.6287 120.891 78.6287C143.518 78.6287 161.86 96.948 161.86 119.546Z",
    fill: "url(#paint14_linear_2112_10424)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_2112_10424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.892 160.468C143.518 160.468 161.86 142.149 161.86 119.551C161.86 96.9531 143.518 78.6338 120.892 78.6338C98.2652 78.6338 79.9229 96.9531 79.9229 119.551C79.9229 142.149 98.2652 160.468 120.892 160.468Z",
    fill: "url(#paint15_linear_2112_10424)",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "path-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2 175.605C90.7175 173.461 93.7672 173.461 94.2847 175.605L95.1545 179.208C95.3395 179.974 95.9377 180.572 96.7039 180.757L100.307 181.627C102.451 182.145 102.451 185.194 100.307 185.712L96.7039 186.582C95.9377 186.767 95.3395 187.365 95.1545 188.131L94.2847 191.734C93.7672 193.878 90.7175 193.878 90.2 191.734L89.3302 188.131C89.1452 187.365 88.547 186.767 87.7808 186.582L84.1775 185.712C82.0335 185.194 82.0335 182.145 84.1775 181.627L87.7808 180.757C88.547 180.572 89.1452 179.974 89.3302 179.208L90.2 175.605Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9177 18.5974C25.4353 16.4534 28.4849 16.4534 29.0025 18.5974L29.8723 22.2007C30.0573 22.9669 30.6555 23.5651 31.4217 23.7501L35.0249 24.6199C37.169 25.1374 37.169 28.1871 35.0249 28.7046L31.4217 29.5745C30.6555 29.7594 30.0573 30.3576 29.8723 31.1238L29.0025 34.7271C28.4849 36.8711 25.4353 36.8711 24.9177 34.7271L24.0479 31.1238C23.863 30.3576 23.2648 29.7594 22.4986 29.5745L18.8953 28.7046C16.7513 28.1871 16.7513 25.1374 18.8953 24.6199L22.4986 23.7501C23.2648 23.5651 23.863 22.9669 24.0479 22.2007L24.9177 18.5974Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.695 17.7109C96.2161 17.7109 97.4492 16.4778 97.4492 14.9567C97.4492 13.4355 96.2161 12.2024 94.695 12.2024C93.1738 12.2024 91.9407 13.4355 91.9407 14.9567C91.9407 16.4778 93.1738 17.7109 94.695 17.7109ZM94.695 19.7766C97.3569 19.7766 99.5149 17.6187 99.5149 14.9567C99.5149 12.2947 97.3569 10.1367 94.695 10.1367C92.033 10.1367 89.875 12.2947 89.875 14.9567C89.875 17.6187 92.033 19.7766 94.695 19.7766Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.499 94.1807C180.166 92.8747 181.372 91.6979 182.669 92.0626L188.312 93.6482C189.61 94.0128 190.026 95.6454 189.061 96.5868L184.867 100.681C183.902 101.622 182.28 101.166 181.947 99.8601L180.499 94.1807Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2306 81.8854C19.5371 81.5541 20.7123 82.7613 20.346 84.0584L18.753 89.6989C18.3867 90.996 16.7536 91.4101 15.8135 90.4443L11.7252 86.2446C10.785 85.2788 11.2429 83.6574 12.5494 83.3261L18.2306 81.8854Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.584 183.943C150.891 183.611 152.066 184.818 151.699 186.116L150.107 191.756C149.74 193.053 148.107 193.467 147.167 192.501L143.079 188.302C142.139 187.336 142.596 185.715 143.903 185.383L149.584 183.943Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.72 57.8271C188.241 57.8271 189.475 56.594 189.475 55.0729C189.475 53.5517 188.241 52.3186 186.72 52.3186C185.199 52.3186 183.966 53.5517 183.966 55.0729C183.966 56.594 185.199 57.8271 186.72 57.8271ZM186.72 59.8928C189.382 59.8928 191.54 57.7349 191.54 55.0729C191.54 52.4109 189.382 50.2529 186.72 50.2529C184.058 50.2529 181.9 52.4109 181.9 55.0729C181.9 57.7349 184.058 59.8928 186.72 59.8928Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.506 28.6786C141.037 28.6786 143.09 26.6263 143.09 24.0947C143.09 21.563 141.037 19.5107 138.506 19.5107C135.974 19.5107 133.922 21.563 133.922 24.0947C133.922 26.6263 135.974 28.6786 138.506 28.6786Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.887 28.6786C157.418 28.6786 159.471 26.6263 159.471 24.0947C159.471 21.563 157.418 19.5107 154.887 19.5107C152.355 19.5107 150.303 21.563 150.303 24.0947C150.303 26.6263 152.355 28.6786 154.887 28.6786Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.269 28.6786C173.801 28.6786 175.853 26.6263 175.853 24.0947C175.853 21.563 173.801 19.5107 171.269 19.5107C168.738 19.5107 166.686 21.563 166.686 24.0947C166.686 26.6263 168.738 28.6786 171.269 28.6786Z",
    fill: "#385BF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2112_10424",
    x: 0.286133,
    y: 95.5276,
    width: 81.23,
    height: 99.5988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2112_10424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2112_10424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2112_10424",
    x: 119.842,
    y: 0,
    width: 81.23,
    height: 56.1858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2112_10424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2112_10424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2112_10424",
    x: 68.5,
    y: 71.2158,
    width: 104.783,
    height: 104.661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2112_10424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2112_10424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_2112_10424",
    x: 64.9229,
    y: 63.6338,
    width: 111.938,
    height: 111.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2112_10424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2112_10424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2112_10424",
    x1: 97.5969,
    y1: -9.2573,
    x2: 99.445,
    y2: 307.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2112_10424",
    x1: 41.0932,
    y1: 62.1267,
    x2: 160.936,
    y2: 41.1232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2112_10424",
    x1: 32.064,
    y1: 128.511,
    x2: 264.914,
    y2: 157.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2112_10424",
    x1: 53.7107,
    y1: 60.0023,
    x2: 139.948,
    y2: 67.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2112_10424",
    x1: 53.7107,
    y1: 85.7259,
    x2: 139.948,
    y2: 93.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2112_10424",
    x1: 53.7107,
    y1: 111.439,
    x2: 139.948,
    y2: 119.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2112_10424",
    x1: 53.7107,
    y1: 137.153,
    x2: 139.948,
    y2: 145.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2112_10424",
    x1: 5.62781,
    y1: 159.718,
    x2: 111.486,
    y2: 168.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2112_10424",
    x1: 16.2166,
    y1: 136.044,
    x2: 53.618,
    y2: 138.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2112_10424",
    x1: 16.5382,
    y1: 164.581,
    x2: 53.612,
    y2: 166.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2112_10424",
    x1: 16.5382,
    y1: 149.642,
    x2: 53.612,
    y2: 151.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2112_10424",
    x1: 16.8093,
    y1: 116.383,
    x2: 34.4258,
    y2: 116.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2112_10424",
    x1: 125.183,
    y1: 31.6356,
    x2: 227.647,
    y2: 52.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2112_10424",
    x1: 152.974,
    y1: 160.66,
    x2: 164.655,
    y2: 147.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2112_10424",
    x1: 72.3904,
    y1: 93.5239,
    x2: 169.809,
    y2: 94.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2112_10424",
    x1: 120.892,
    y1: 78.6338,
    x2: 162.084,
    y2: 185.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAutoFilledIcon);
export default __webpack_public_path__ + "static/media/new-auto-filled-icon.23436c3b021552bf59807c9819be488e.svg";
export { ForwardRef as ReactComponent };